export const userRoleMixin = {
  methods: {
    userType(accountType) {
      /* let accountCode;

      switch (accountType.toLowerCase()) {
        case 'admin':
          accountCode = 12;
          break;

        case 'recruiter':
          accountCode = 11;
          break;

        case 'manager':
          accountCode = 2;
          break;

        case 'user':
          accountCode = 1;
          break;

        case 'candidate':
          accountCode = 0;
          break;

        default:
          accountCode = -1;
          break;
      }

       return accountCode; */
      return accountType;
    },
  },
};
